import React, { useState, Fragment, useEffect } from "react";

import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import { getColorForNumber } from "../../../utils/helpers";
import cn from "clsx";

const PreviousRounds = ({ roundsHistory, preNumbersUOText, firstNumberUOText }) => {
  const [autoHeightMaxScrollBar, setAutoHeightMaxScrollbar] = useState(1000);
  const { t } = useTranslation();

  useEffect(() => {
    setAutoHeightMaxScrollbar(
      document.querySelector(".basket").offsetHeight * 0.895
    );
  }, []);

  const getResultValue = (betResults, betType) => {
    for (const result of betResults) {
      if (Number(result.BetType) === Number(betType))
        return Number(result.Value);
    }
  };

  const getStarsPosition = (index, startList) => {
    if(startList && startList.length > 0){
      return startList.includes(index) ? 'star' : ''
    }
    return ''
  };

  const mostFrequentColors = (balls) => {
    let resultColors = [];
    const counts = {};
    balls.map(ball => getColorForNumber(Number(ball))).forEach(i => { counts[i] = 1 + (counts[i] || 0) })
    let maxColor = Math.max.apply(null, Object.values(counts))
    Object.keys(counts).forEach( i => {
      if(counts[i] === maxColor) resultColors.push(i)
    })
    return resultColors
  }

  const isMoreEvenBalls = (balls) => {
    let odd = 0,
        even = 0;
    balls.forEach(i => { i % 2 ? odd++ : even++ })
    return even > odd
  }

  return (
    <section className="previous-rounds">
      <Scrollbars autoHeight autoHeightMin={autoHeightMaxScrollBar}>
        {roundsHistory.length === 0 && <div className="align-center">{t("prevRounds.emptyMessage")}</div>}
        {roundsHistory.map((event, i) => {
          return (
            <Fragment key={i}>
              <div className="flex-row bet-content-row">
                <div className="flex-col-11 font-light mb-5">{t("prevRounds.drawnNumbers")}</div>
                <div className="flex-col-10 align-right font-light">
                  {t("prevRounds.round")} {event.RoundNumber}
                </div>
              </div>
              <div className="statistics-balls-container flex-row justify-around">
                {event.Entries.map((ball, index) => {
                  return (
                    <div
                      key={`${ball}`}
                      className={cn(`spaceholder-balls flex-row`, {
                        [getStarsPosition(index, event.StarsPositionList)]: true,
                        [getColorForNumber(Number(ball))]: true
                      })}
                      style={{ marginRight: "0.2vw" }}
                    >
                      <span className="ball-number">{ball}</span>
                    </div>
                  );
                })}
              </div>

              {/* First number even/odd: EVEN */}
              <div
                className="flex-row bet-content-row"
                // style={{ marginLeft: "1rem" }}
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("prevRounds.firstBall")}:{" "}
                  <span className={"font-normal"}>
                    {getResultValue(event.BetResults, 2) === 1 ? t('bets.even').toUpperCase() : t('bets.odd').toUpperCase()}
                  </span>{" "}
                  ({event.Entries && event.Entries[0]})
                </div>
              </div>
              {/* First number -24.5+ under over */}
              <div
                className="flex-row bet-content-row"
                // style={{ marginLeft: "1rem" }}
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("prevRounds.firstBall")} {firstNumberUOText}:{" "}
                  <span className={"font-normal"}>
                    {getResultValue(event.BetResults, 3) === 1
                      ? t('bets.under').toUpperCase()
                      : t('bets.over').toUpperCase()
                    }
                  </span>{" "}
                  ({event.Entries && event.Entries[0]})
                </div>
              </div>
              {/* Pre Numbers Sum (even/odd) */}
              <div
                className="flex-row bet-content-row"
                // style={{ marginLeft: "1rem" }}
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("prevRounds.preBalls")}:{" "}
                  <span className={"font-normal"}>
                    {getResultValue(event.BetResults, 4) === 1 ? t('bets.even').toUpperCase() : t('bets.odd').toUpperCase()}
                  </span>{" "}
                </div>
              </div>
              {/* Pre Numbers Sum (under/over) -{preNumbersUOText}+ */}
              <div
                className="flex-row bet-content-row"
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("prevRounds.preBallsSum")} {preNumbersUOText}:{" "}
                  <span className={"font-normal"}>
                    {getResultValue(event.BetResults, 5) === 1
                      ? t('bets.under').toUpperCase()
                      : t('bets.over').toUpperCase()}
                  </span>
                  (
                  {event.Entries.slice(0, 5).reduce(
                    (accumulator, currentValue) => {
                      return Number(accumulator) + Number(currentValue);
                    }
                  )}
                  )
                </div>
              </div>

              {/* First ball color */}
              <div
                className="flex-row bet-content-row"
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("prevRounds.firstBallColor")}:{" "}{" "}
                  <span className={`color-alias alias-${getColorForNumber(Number(event.Entries[0]))}`}></span>
                </div>
              </div>

              {/* Last Ball Color */}
              <div
                  className="flex-row bet-content-row"
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("LastBallColor")}:{" "}{" "}
                  <span className={`color-alias alias-${getColorForNumber(Number(event.Entries[event.Entries.length -1]))}`}></span>
                </div>
              </div>

              {/* Color Betting (for Most Frequent Color[s]) */}
              <div
                  className="flex-row bet-content-row"
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("MostFrequentColor")}:{" "}{" "}
                  <span dangerouslySetInnerHTML={ { __html: mostFrequentColors(event.Entries).map(i => `<span class="color-alias alias-${i}"></span>`) } }></span>
                </div>
              </div>

              {/* More Even or Odd */}
              <div
                  className="flex-row bet-content-row"
              >
                <div className="flex-col-21 font-light mb-5">
                  {t("moreEvenOrOdd")}:{" "}{" "}
                  <span className={"font-normal"}>
                    { isMoreEvenBalls(event.Entries) ? t('bets.even').toUpperCase() : t('bets.odd').toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="bet-content-divider"></div>
            </Fragment>
          );
        })}
      </Scrollbars>
    </section>
  );
};

export default PreviousRounds;